import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, ExternalLink } from 'lucide-react';

import { EMBED_URL } from './booking.config';

export default function BookingModal({ isOpen, onClose, title }) {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener('keydown', onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;
  const isFr = (localStorage.getItem('januslang') || localStorage.getItem('janus_lang')) === 'Fr';

  return createPortal(
    <div
      className="fixed inset-0 z-[300] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div
        className="relative flex h-[88vh] w-full max-w-4xl flex-col overflow-hidden bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <h2 className="text-[10px] font-black uppercase tracking-[0.3em] text-[var(--color-black)]">{title}</h2>
          <div className="flex items-center gap-5">
            <a
              href="/book"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-gray-500 transition hover:text-[var(--color-gold)]"
            >
              {isFr ? 'Ouvrir dans un nouvel onglet' : 'Open in a new tab'} <ExternalLink size={12} />
            </a>
            <button type="button" onClick={onClose} aria-label={isFr ? 'Fermer' : 'Close'} className="text-gray-500 transition hover:text-black">
              <X size={20} />
            </button>
          </div>
        </div>
        <iframe src={EMBED_URL} title={title} className="h-full w-full flex-1 border-0" />
      </div>
    </div>,
    document.body
  );
}
